import { render } from "./documentosList.vue?vue&type=template&id=7bd2fb80"
import script from "./documentosList.vue?vue&type=script&lang=js"
export * from "./documentosList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__